export default "__VITE_ASSET__Buuw2j6o__"